<template>
	<div class="container tac">
		<div class="m_sub_top">
			<div class="top_content">
				<div class="headline">
					<p class="headline_m">
						{{ $t('rtr_business-how-risk.title1') }}<br />
						{{ $t('rtr_business-how-risk.title2') }}
					</p>
					<p class="body_m">
						{{ $t('rtr_business-how-risk.text1') }}
						{{ $t('rtr_business-how-risk.text2') }}
					</p>
				</div>
			</div>
		</div>
		<section>
			<div class="m_sub_middle body_l">
				<p>{{ $t('rtr_business-how-risk.text3') }}</p>
				<button class="button_bg_red" @click="$router.push({ name: 'cs' })">
					{{ $t('rtr_business-how-risk.text4') }}
				</button>
			</div>
			<div class="content_area">
				<div class="m_sub_bottom">
					<h2 class="headline_m">
						{{ $t('rtr_business-how-risk.title3') }}
					</h2>
					<p class="body_m">
						{{ $t('rtr_business-how-risk.text5') }}<br />
						{{ $t('rtr_business-how-risk.text6') }}
					</p>
				</div>
			</div>
		</section>
		<section class="content_area pb_10">
			<div class="detail_area">
				<div class="detail">
					<h2 class="headline_s">
						{{ $t('rtr_business-how-risk.title4') }}
					</h2>
					<div class="img_area_02">
						<img src="@/assets/images/sub/business_risk_02.png" alt="" />
					</div>
					<div class="text">
						<p class="body_m">
							{{ $t('rtr_business-how-risk.text7') }}
							{{ $t('rtr_business-how-risk.text8') }}
						</p>
					</div>
				</div>
			</div>
			<div class="detail_area">
				<div class="detail">
					<h2 class="headline_s">
						{{ $t('rtr_business-how-risk.title5') }}
					</h2>
					<div class="img_area_02">
						<img src="@/assets/images/sub/business_risk_03.png" alt="" />
					</div>
					<div class="text">
						<p class="body_m">
							{{ $t('rtr_business-how-risk.text9') }}<br />
							{{ $t('rtr_business-how-risk.text10') }}
						</p>
					</div>
				</div>
			</div>
		</section>
	</div>
</template>

<script>
import '@/assets/css/sub.m.css';
export default {
	name: 'Risk.m',
};
</script>

<style scoped></style>
